export default __webpack_public_path__ + "static/media/pro.1e6b0084.jpg";